<template>
    <div class="center-principle">
        <div class="top-head">
            <img src="../../assets/imgs/center/principle-1.png" style="width: 100%;" />
            <div class="head-box">
                <div>教室设计原则</div>
                <img src="../../assets/imgs/center/principle-2.png" style="height: 74%;margin-top:3.6%">
            </div>
        </div>
        <div style="width: 1000px;margin:80px auto;">

            <div class="group">
                <div style="  display: flex;justify-content: space-between;">
                    <div class="title">安全</div>
                    <div class="box">安全是七田真中心环境的第一准则。<br/>
                        严格的除甲醛程序、有曲度的墙面设计、6.5-10cm架空地板精心装修，特制光源更加柔和并配有防眩光罩、具有强大除螨功能的地毯、国际领先的APO+安全净水技术……只为给孩子一个安全健康的学习环境。
                    </div>
                </div>
            </div>

            <div class="group">
                <div style="  display: flex;justify-content: space-between;">
                    <div class="title">环保</div>
                    <div class="box"><br/>空间全部选用环保材料，教室家具也利用可回收的塑料制品再创造，为孩子埋下一颗富有环保意识的爱心种子。
                    </div>
                </div>
            </div>

            <div class="group">
                <div style="  display: flex;justify-content: space-between;">
                    <div class="title">自然</div>
                    <div class="box">七田真尊重孩子的天性，空间最大限度地引进自然光线。<br/>
                        活动区屹立着的巨大的智慧树，大小不一的卵石豆袋座椅，以家为原型设计的小木屋，可以自由涂鸦的墙面黑板漆……给孩子们一个自由生长的空间。
                    </div>
                </div>
            </div>

            <div class="group">
                <div style="  display: flex;justify-content: space-between;">
                    <div class="title">爱 </div>
                    <div class="box"> 所有的设计都是以孩子的视角出发，更符合孩子身心发展的特点。<br/>
                        教室内部空间转角导圆的设计，具有很强的环抱感，就像在妈妈怀中一样温暖。
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
    }
</script>
<style lang="less" scoped>
    .center-principle{
        .top-head{
            font-weight: 600;
            font-size: 40px;
            position: relative;
            .head-box{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 1000px;
                margin: 0px auto;
                font-size: 48px;
                font-weight: 600;
                color: #303030;
                height: 60%;
            }
        }

        .group{
            display: inline-block;
            width:470px;
            height: 280px;
            margin-right: 50px;
            &:nth-child(2n+2){
                margin-right: 0px;
            }
        }

        .title{
            display: inline-block;
            width:50px;
            height: 100%;
            border-top: 4px solid #fbc200;
            font-size: 24px;
            font-weight: 600;
            /* line-height: 50px; */
            padding-top: 20px;
            /* margin-right: 50px; */
        }
        .box{
            display: inline-block;
            width:355px;
            height: 100%;
            border-top: 4px solid #eeefef;
            font-size: 16px;
            font-family: Light;
            line-height: 26px;
            padding-top: 20px;
        }
    }
</style>
